import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./partnerDashboard.css";

const NAV_ITEMS = [
  { to: "/partner/dashboard", label: "Overview", end: true },
  { to: "/partner/dashboard/assistant", label: "Ask Priya" },
  { to: "/partner/dashboard/requests", label: "Requests" },
  { to: "/partner/dashboard/quotes", label: "My Quotes" },
  { to: "/partner/dashboard/services", label: "Services" },
  { to: "/partner/dashboard/packages", label: "Packages" },
  { to: "/partner/dashboard/bookings", label: "Bookings" },
  { to: "/partner/dashboard/earnings", label: "Earnings" },
  { to: "/partner/dashboard/reviews", label: "Reviews" },
  { to: "/partner/dashboard/disputes", label: "Disputes" },
  { to: "/partner/dashboard/offers", label: "Offers" },
  { to: "/partner/dashboard/referrals", label: "Referrals" },
  { to: "/partner/dashboard/profile", label: "Business Profile" },
];

export default function PartnerLayout() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("partner_profile");
      if (raw) setProfile(JSON.parse(raw));
    } catch {
      setProfile(null);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem("partner_token");
    localStorage.removeItem("partner_profile");
    navigate("/partner/login");
  };

  return (
    <Container fluid className="partner-dashboard py-4">
      <Row>
        <Col md={3} lg={2} className="mb-4">
          <div className="partner-sidebar">
            <div className="mb-3">
              <h5 className="mb-0">{profile?.businessName || "Partner"}</h5>
              <small className="text-muted">{profile?.verificationStatus || "Pending"}</small>
            </div>
            <nav className="d-flex flex-column gap-1">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `partner-nav-link${isActive ? " active" : ""}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <Button variant="outline-secondary" size="sm" className="w-100 mt-3" onClick={logout}>
              Log out
            </Button>
          </div>
        </Col>
        <Col md={9} lg={10}>
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}
